{
  "dss": {
    "button": {
      "back": "Retour",
      "cancel": "Annuler",
      "close": "Fermer",
      "confirmDelete": "Oui, supprimer",
      "continue": "Continuer",
      "logout": "Déconnexion",
      "passwordReset": "Réinitialiser le mot de passe",
      "save": "Sauvez",
      "verify": "Vérifier"
    },
    "error": {
      "403": "Vous n'avez pas accès à cette page.",
      "404": "Cette page n'existe pas.",
      "generic": "Une erreur s'est produite. Veuillez réessayer plus tard.",
      "invalidConfirmationLink": "Le lien de confirmation a expiré ou n'est pas valide.",
      "throttling": "Trop de tentatives. Cette opération est bloquée pendant un certain temps.",
      "title": "Erreur",
      "title403": "Accès refusé",
      "title404": "Non trouvé"
    },
    "footer": {
      "imprint": "Mentions Légales",
      "legalEntity": "ANDREAS STIHL SAS, 1 rue des Epinettes, ZI Nord de Torcy, 77200 Torcy, France",
      "privacy": "Politique de confidentialité",
      "terms": "Conditions générales d'utilisation"
    },
    "label": {
      "CRMAccountNumber": "Numéro de compte",
      "contact": "Contacter",
      "email": "Email",
      "faq": "FAQ",
      "female": "Mme",
      "firstname": "Prénom",
      "help": "Help",
      "language": "Langue",
      "lastname": "Nom",
      "male": "M.",
      "needHelp": "Besoin d'aide?",
      "newPassword": "Nouveau mot de passe",
      "newPassword2": "Confirmez le nouveau mot de passe",
      "oldPassword": "Ancien mot de passe",
      "organization": "Revendeur",
      "password": "Mot de passe",
      "required": "requis",
      "salutation": "Civilité",
      "select": "Veuillez sélectionner"
    },
    "lang": {
      "fr": "Français"
    },
    "link": {
      "contact": "https://support.stihl.com/fr-FR/websso-contact/",
      "faq": "https://support.stihl.com/fr-FR/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Confirmer l'inscription",
        "wait": "Veuillez attendre la confirmation du compte."
      },
      "otp": {
        "btnResend": "Renvoyer l'email du code de vérification",
        "msg": {
          "invalidOTP": "Le mot de passe à usage unique saisi n'est pas valide.",
          "resendFail": "Impossible de renvoyer le code. Veuillez réessayer plus tard."
        },
        "spamDetail": "Vérifiez votre boîte de réception et votre dossier de courrier indésirable pour un courriel du service d'assistance STIHL. (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Vous n'avez pas reçu d'email ?",
        "subtitle": "Afin de continuer, vous devez vérifier votre adresse e-mail.",
        "title": "Vérifier votre compte utilisateur",
        "txtVerifyMail": "Veuillez entrer le nouveau code de vérification que nous avons envoyé à votre adresse e-mail {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Il n'y a rien à mettre à jour.",
          "updateError": "Défaut de mise à jour des données personnelles.",
          "updated": "Les données personnelles ont été mises à jour.",
          "userLoadErr": "Erreur de chargement des données utilisateur. Veuillez réessayer plus tard."
        },
        "secOrganization": "Organisation",
        "secPersonal": "Personnel",
        "secSettings": "Paramètres préférés",
        "title": "Informations personnelles"
      },
      "postPwSet": {
        "info": "Vous pouvez maintenant utiliser votre nouveau mot de passe.",
        "link_name": "Retourner sur stihl.fr",
        "link_url": "https://www.stihl.fr",
        "title": "Votre nouveau mot de passe a été sauvegardé"
      },
      "resetPW": {
        "title": "Réinitialiser votre mot de passe"
      },
      "security": {
        "2fa": {
          "availableMethods": "Méthodes d'authentification 2FA disponibles :",
          "info": "L'authentification à deux facteurs (2FA) est une fonctionnalité de sécurité qui ajoute une couche supplémentaire de protection à votre compte. Elle nécessite que vous utilisiez deux méthodes pour vous connecter, au lieu d'un simple nom d'utilisateur et mot de passe.",
          "method": {
            "email": "Email",
            "emailDesc": "Recevez des codes uniques envoyés par e-mail pour compléter les demandes d'authentification.",
            "oath": {
              "add": {
                "button": "Enregistrer une application d'authentification"
              }
            }
          }
        },
        "authenticator": "Application d'authentification",
        "infoFederatedAccount": "Ce compte est géré par le fournisseur d'identité de votre organisation, le mot de passe ne peut donc pas être modifié ici. Pour changer votre mot de passe, connectez-vous via la page de connexion de votre organisation ou contactez votre administrateur informatique.",
        "lastUse": "Dernière utilisation à {0}.",
        "msg": {
          "invalidPassword": "Le mot de passe actuel fourni est invalide.",
          "passwordAlreadyUsed": "Impossible de réutiliser les 5 derniers mots de passe.",
          "pwUpdateError": "Une erreur s'est produite lors de la tentative de changement de mot de passe.",
          "pwUpdated": "Le mot de passe a été changé."
        },
        "noDevice": "Non configuré",
        "oathAdd": {
          "appInfo": "Les applications d'authentification telles que {0}, {1}, etc. génèrent des mots de passe à usage unique qui sont utilisés comme deuxième facteur lors de la connexion.",
          "badCode": "Code invalide, veuillez réessayer.",
          "error": "Une erreur s'est produite lors de la tentative d'enregistrement du périphérique d'authentification.",
          "headScan": "1. Scannez le code QR avec votre application d'authentification",
          "headVerify": "2. Vérifiez le code",
          "infoKey": "clé de configuration",
          "infoKeyTitle": "Votre secret à deux facteurs",
          "infoScanBottom": "Impossible de numériser? Vous pouvez utiliser le {0} pour configurer manuellement votre application d'authentification.",
          "infoVerify": "Entrez le code généré par votre application d'authentification.",
          "success": "Votre appareil d'authentification a été enregistré. Vous pouvez maintenant l'utiliser pour vous connecter.",
          "title": "Enregistrez votre appareil d'authentification à deux facteurs"
        },
        "oathDelete": {
          "error": "Une erreur s'est produite lors de la tentative de suppression du périphérique d'authentification.",
          "success": "Le périphérique d'authentification a été supprimé."
        },
        "passkeys": {
          "about": {
            "info1": "Les clés d'accès sont des paires de clés cryptographiques (une clé publique et une clé privée) qui sont stockées par un authentificateur que vous contrôlez. L'authentificateur peut prouver qu'un utilisateur est présent et autorisé à utiliser la clé d'accès. Les authentificateurs vérifient l'autorisation à l'aide d'un code PIN, d'un mot de passe, de données biométriques ou du mot de passe de l'appareil, en fonction des capacités et de la configuration de l'authentificateur. Les authentificateurs se présentent sous de nombreuses formes, comme un iPhone ou un appareil Android, Windows Hello, une clé de sécurité matérielle FIDO2 ou un gestionnaire de mots de passe.",
            "info2": "Lorsque vous vous connectez à STIHL en utilisant une clé d'accès, votre authentificateur utilise la cryptographie à clé publique pour prouver votre identité à STIHL sans jamais envoyer la clé d'accès. Les clés d'accès sont liées à un domaine de site web, tel que stihl-sso.com, et nécessitent une connexion sécurisée, ce qui signifie que le navigateur web refusera de s'authentifier sur un site de phishing. Ces propriétés rendent les clés d'accès hautement résistantes au phishing et beaucoup plus difficiles à attaquer que les SMS ou la 2FA TOTP, qui peuvent être exposés au phishing.",
            "info3": "Les services de stockage de clés d'accès basés sur le cloud permettent de synchroniser les clés d'accès entre les appareils (comme les appareils Apple, Android ou les gestionnaires de mots de passe) pour les rendre accessibles depuis plusieurs endroits et moins susceptibles d'être perdues. Une fois qu'une clé d'accès synchronisée est configurée sur un appareil, elle est disponible sur plusieurs appareils utilisant le même service. Par exemple, si vous enregistrez une clé d'accès avec votre compte iCloud à l'aide de l'identifiant tactile de votre MacBook, vous pouvez ensuite utiliser cette clé d'accès avec votre visage, empreinte digitale, code PIN ou mot de passe de l'appareil de manière interchangeable sur plusieurs appareils liés au même compte iCloud.",
            "title": "À propos des clés d'accès"
          },
          "add": {
            "button": "Ajouter une nouvelle clé d'accès",
            "error": "Une erreur s'est produite lors de la tentative d'ajout de la nouvelle clé d'accès.",
            "success": "Une nouvelle clé d'accès a été ajoutée."
          },
          "delete": {
            "button": "Supprimer la clé d'accès",
            "error": "Une erreur s'est produite lors de la tentative de suppression de cette clé d'accès.",
            "success": "La clé d'accès a été supprimée."
          },
          "edit": {
            "error": "Une erreur s'est produite lors de la tentative de sauvegarde du nom de la clé d'accès.",
            "name": "Nom de la clé d'accès",
            "success": "Le nom de la clé d'accès a été mis à jour.",
            "title": "Donnez un nom à votre clé d'accès pour la distinguer des autres clés d'accès"
          },
          "info": "La clé d'accès est une alternative simple et sécurisée aux mots de passe, qui valide votre identité à l'aide d'un toucher, d'une reconnaissance faciale, d'un mot de passe de l'appareil ou d'un code PIN.",
          "none": "Aucune clé d'accès configurée.",
          "reallyDelete": "Êtes-vous sûr de vouloir supprimer la clé d'accès ?",
          "registeredPasskeys": "Vos clés d'accès enregistrées :",
          "title": "Clés d'accès"
        },
        "reallyDeleteDevice": "Êtes-vous sûr de vouloir supprimer le périphérique d'authentification ?",
        "secMFA": "Authentification multifacteur",
        "secPwdChange": "Modifier le mot de passe",
        "title": "Identification & Sécurité"
      },
      "setPW": {
        "acceptTC": "Veuillez confirmer nos {terms} et lire nos {privacy}.",
        "killSSO": "Invalider les sessions actives",
        "msg": {
          "tokenExpired": "Le lien ou le code du mot de passe a expiré. Veuillez suivre le lien pour réinitialiser votre mot de passe: {link}."
        },
        "privacy": "Politique de confidentialité",
        "terms": "Conditions générales d'utilisation",
        "title": "Saisissez le nouveau mot de passe"
      }
    },
    "validations": {
      "hasDigit": "Doit contenir un ou plusieurs chiffres",
      "hasLowercase": "Doit contenir un ou plusieurs caractères minuscules",
      "hasSpecial": "Doit contenir un ou plusieurs caractères spéciaux: {chars}",
      "hasUppercase": "Doit contenir un ou plusieurs caractères majuscules",
      "invalidCharacters": "Contient des caractères non valides",
      "maxLength": "Maximum {max} de caractères autorisés",
      "minLength": "Minimum {min} de caractères requis",
      "notSameAsEmail": "Trop similaire à l'adresse e-mail",
      "onlyValidCharactersAllowed": "Seules les lettres, les chiffres et les espaces sont autorisés.",
      "required": "Valeur requise",
      "sameAsPassword": "Les mots de passe ne correspondent pas",
      "tcAccepted": "Veuillez accepter nos conditions d'utilisation STIHL.",
      "validEmail": "Adresse électronique non valide.",
      "validOTP": "Veuillez entrer le code de vérification."
    }
  }
}
